export default __webpack_public_path__ + "static/media/DataAnalystQA.1bfa07ec.png";